import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DatepickerOptions, NgDatepickerComponent } from 'ng2-datepicker';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TagInputComponent } from 'ngx-chips';
import { distanceInWordsToNow, addDays, compareAsc, differenceInDays, format, getTime } from 'date-fns';
import * as locale from 'date-fns/locale/es';
import * as es from 'date-fns/locale/es';

import groupBy from 'lodash/groupBy';
import { Observable, of } from 'rxjs';
import { catchError, switchMap, tap, map } from 'rxjs/operators';

import deburr from 'lodash/fp/deburr';
import lowerCase from 'lodash/fp/lowerCase';
import sortBy from 'lodash/fp/sortBy';
import flow from 'lodash/fp/flow';

const themesSort: any = sortBy(flow( (t: any) => t.title,  deburr, lowerCase ));

const locales = { es };
const placeholders = {
  es: 'Selecciona fecha'
};
const defaultFormat = {
  es: 'D/MM/YYYY'
};

@Component({
  selector: 'bidi-content-publicator',
  templateUrl: './content-publicator.component.html',
  styleUrls: ['./content-publicator.component.scss']
})
export class ContentPublicatorComponent implements OnInit, OnChanges {
  @Input() resource;
  @Input() saveResource;
  @Input() themes;
  @Input() dataEditResource;
  @Input() dateSelect;
  @Output() close = new EventEmitter<boolean>();
  @Output() resSelected = new EventEmitter<any>();
  @Output() newTheme = new EventEmitter<boolean>();
  @Output() showPreviewContent = new EventEmitter<boolean>();
  isOpen = true;
  themeSelect: any;
  theme: any;
  sinceDate;
  data: any;
  finalOptions: DatepickerOptions;
  resourceProcessed;
  idContent: any;
  startDate: any;
  endDate: any;
  flag = false;
  msgErr: string;
  msgErrT: string;
  msgErrDatePlanning: boolean;
  contentEdit = false;
  titleE: string;
  abstractE: string;
  tagsCustom = [];
  tagsContenido = [];
  private innerValue;
  private onChangeCallback: (_: Date) => void;

  role = 'teacher';

  // form: FormGroup;

  get value () {
    return this.innerValue;
  }

  set value (date: Date) {
    if (this.innerValue !== date) {
      this.innerValue = date;
    }

    if (this.onChangeCallback) {
      this.onChangeCallback(this.innerValue);
    }
  }

  private defaultOptions: DatepickerOptions = {
    barTitleFormat: 'MMMM YYYY',
    dayNamesFormat: 'dd',
    firstCalendarDay: 1,
    addClass: 'input',
    useEmptyBarTitle: false,
    locale: es
  };

  constructor(
  ) {}

  ngOnInit () {
    this.getContEje();
    this.msgErrDatePlanning = false;
    this.sinceDate = distanceInWordsToNow(
      new Date(this.resource.processed_at),
      { locale, addSuffix: true }
    );

    this.startDate = this.dateSelect.selectedDate;
    this.endDate = this.dateSelect.selectedDate;

    if (this.dataEditResource) {
      this.endDate = addDays(addDays(this.dataEditResource.startDate, 1), this.dataEditResource.duration);
      this.startDate = addDays(this.dataEditResource.startDate, 1);
      this.themeSelect = this.dataEditResource.theme;
      this.theme = this.dataEditResource.theme;
      this.idContent = this.dataEditResource._id;
    }

    this.finalOptions = Object.assign(
      {
        displayFormat: defaultFormat['es'],
        locale: locales['es'],
        placeholder: placeholders['es']
      },
      this.defaultOptions,
      {}
      // this.options
    );
  }

  ngOnChanges (changes) {
    if (changes.resource) {
      if (this.resource.type === 'planning') {
        const groupedContents = groupBy(this.resource.contents, 'theme._id');
        this.resourceProcessed = {
          ...this.resource,
          themes: this.resource.themes.map(theme => ({
            ...theme, contents: groupedContents[theme._id]
          }))
        };
      } else {
        this.resourceProcessed = this.resource;
      }
    }
  }

  selectThemeForContent(t) {
    this.theme = t;
  }

  validResources(date, contents) {
    let flagTmp = false;
    contents.map( function (c) {
      const dateCal = addDays(date, c.offset);
      if (format(dateCal, 'YYYY') > format(date, 'YYYY')) {
        flagTmp = true;
        return false;
      }
    });
    this.msgErrDatePlanning = flagTmp;
  }

  closeModal () {
    this.msgErrDatePlanning = false;
  }

  saveResourceSelected(res) {
    this.msgErr = '';
    this.msgErrT = '';
    this.flag = false;
    const startDate = format(this.startDate, 'YYYY-MM-DD');
    const endDate = format(this.endDate, 'YYYY-MM-DD');
    const durationCustom = differenceInDays(endDate, startDate);
    if (!this.startDate) {
      this.flag = true;
      this.msgErr = 'Debes seleccionar una fecha';
    }
    if (res.type !== 'planning') {
      if (durationCustom < 0) {
        this.flag = true;
        this.msgErr = 'La fecha de vencimiento no puede ser inferior a la fecha de disponibilidad';
      }
      if (!this.theme) {
        this.msgErrT = 'Debes elegir un tema';
        this.flag = true;
      }
    }

    if (!this.flag) {
      if (res.type !== 'planning') {
        this.data = {
          'resource': [this.editObj(this.resourceProcessed)],
          'theme': this.theme,
          'date': this.startDate,
          'idContent': this.idContent,
          'duration': (durationCustom > 0) ? durationCustom : 1,
          'update': (this.dataEditResource) ? true : false
        };
      } else {
        res.title = (this.titleE) ? this.titleE : this.resourceProcessed.title;
        this.data = { 'planning': res, 'date': this.startDate };
      }
      this.resSelected.emit(this.data);
      this.closePreview();
    }
  }

  editResourceSelected() {
    this.contentEdit = true;
  }

  showPreview () {
    this.showPreviewContent.emit();
  }

  addTheme() {
    this.newTheme.emit(true);
  }

  closePreview () {
    this.isOpen = false;
    this.close.emit(this.isOpen);
  }

  editObj (res) {
    const tagsCustom = this.tagsCustom.map(name => ({ name, type: 'manual' }));
    return {
      ...res,
      'abstract': (this.abstractE) ? this.abstractE : res.abstract,
      'tags': (tagsCustom) ? res.tags.concat(tagsCustom) : res.tags,
      'title': (this.titleE) ? this.titleE : res.title
    };
  }

  getContEje() {

    this.tagsContenido = themesSort(this.resourceProcessed.tags.filter((tag) => tag.type === 'contenido'));
  }

}
